export enum VerificationStatusEnum {
    FACE_DETECTOR_LOADING = 'faceDetectorLoading',
    FACE_DETECTOR_LOADING_SILENT = 'faceDetectorLoadingSilent',
    FACE_DETECTOR_LOADING_ERROR = 'faceDetectorLoadingError',
    READY = 'ready',
    FACE_FOUND = 'faceFound',
    ALIGN_FACE = 'alignFace',
    FACE_NOT_FOUND = 'faceNotFound',
    CHECK_FACE_BY_BE_IN_PROGRESS = 'checkFaceByBeInProgress',
    POOR_LIGHTING = 'poorLighting',
}
